import React, { createContext, useState, useMemo } from 'react';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import { useBookingHistory } from 'services/laundry/booking-history';

export const BookingHistoryContext = createContext();

export const BookingHistoryProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedResourceType, setSelectedResourceType] = useState('');

  const { from, to } = useMemo(() => ({
    from: format(startOfMonth(selectedDate), 'yyyy-MM-dd'),
    to: format(endOfMonth(selectedDate), 'yyyy-MM-dd'),
  }), [selectedDate]);

  const { bookingHistory, isFetching } = useBookingHistory({
    from,
    to,
    resourceType: selectedResourceType,
  });

  const value = useMemo(() => ({
    selectedDate,
    setSelectedDate,
    selectedResourceType,
    setSelectedResourceType,
    bookingHistory,
    isFetching,
    from,
    to,
  }), [selectedDate, selectedResourceType, bookingHistory, isFetching, from, to]);

  return (
    <BookingHistoryContext.Provider value={value}>
      {children}
    </BookingHistoryContext.Provider>
  );
};

export const useBookingHistoryContext = () => {
  const context = React.useContext(BookingHistoryContext);
  if (!context) {
    throw new Error('useBookingHistoryContext must be used within BookingHistoryProvider');
  }
  return context;
};
